import { STRINGS } from 'config';

const {
  APP: {
    RESET_ALL_STATE,
    SET_PRACTICE,
    SET_USER_DATA,
  },
  USER_MANAGEMENT: {
    API_GET_USER_ROLES_SUCCESS,
  },
} = STRINGS.REDUCERS;

export const initialAppState = {
  selectedPractice: null,
  selectedPracticeIsEhub: null,
  selectedPracticeHasAdminRights: null,
  selectedPracticeUserRoles: [],
  user: {
    practices: [],
    ehubs: [],
    adminRights: [],
    currentUserEmail: null,
    roles: [],
    currentUserName: null,
    currentUserPracticeRole: null,
  },
};

export const appReducer = (state, action) => {
  switch (action.type) {
    case RESET_ALL_STATE: {
      return { ...initialAppState, selectedPractice: state.selectedPractice };
    }
    case SET_PRACTICE: {
      return {
        ...state,
        selectedPractice: action.payload.practice,
        selectedPracticeIsEhub: action.payload.isEhub,
        selectedPracticeHasAdminRights: state.user.adminRights.includes(action.payload.practice.id),
      };
    }
    case SET_USER_DATA: {
      const { adminRights, selectedPractice } = action.payload;
      return {
        ...state,
        selectedPractice: selectedPractice,
        selectedPracticeIsEhub: selectedPractice.isEhub,
        selectedPracticeHasAdminRights: adminRights?.includes(selectedPractice.id),
        user: action.payload,
      };
    }
    case API_GET_USER_ROLES_SUCCESS: {
      return { ...state, selectedPracticeUserRoles: action.payload };
    }
    default: {
      return state;
    }
  }
};
